import React from "react";
import { FormattedMessage } from "react-intl";

import { DeviceWithType } from "../../../../../components/devices/DeviceWithType";
import { singleDeviceIdSort } from "../../../../../components/table/helpers/sorting.helper";
import { Manufacturer } from "../../../../../components/manufacturer/Manufacturer";
import { OnlineDevicesDropdownActions, TableCard } from "./components";

export const COLUMNS = [
  {
    Header: <FormattedMessage id={"device_id_devices_table_header"} />,
    accessor: "id",
    sortable: true,
    Cell: ({
      row: {
        original: { id, type },
      },
    }) => <DeviceWithType type={type} identifier={id} />,
    sortType: singleDeviceIdSort,
  },
  {
    Header: <FormattedMessage id={"manufacturer_devices_table_header"} />,
    accessor: "manufacturer",
    sortable: true,
    Cell: ({
      row: {
        original: { manufacturer },
      },
    }) => <Manufacturer manufacturer={manufacturer} />,
  },
  {
    id: "actions",
    sortable: false,
    Header: <FormattedMessage id={"actions"} />,
    headerClassName: "table__cell--small-cell",
    cellClassName: "table__cell--center table__cell--overflow",
    Cell: ({
      row: {
        original: { id, type, manufacturer },
      },
    }) => (
      <OnlineDevicesDropdownActions
        identifier={id}
        type={type}
        manufacturer={manufacturer}
      />
    ),
  },
];

export const COLUMNS_MOBILE = [
  {
    accessor: "id",
    cellClassName: "table__cell--overflow",
    SortingLabel: <FormattedMessage id={"device_id_devices_table_header"} />,
    Cell: ({
      row: {
        original: { type, manufacturer, id },
      },
    }) => <TableCard type={type} manufacturer={manufacturer} identifier={id} />,
    sortType: singleDeviceIdSort,
  },
  {
    accessor: "manufacturer",
    SortingLabel: <FormattedMessage id={"manufacturer_devices_table_header"} />,
  },
];

export const SEARCH_KEYS = ["id", "manufacturer"];
